module.exports = __webpack_public_path__ + "static/media/food-logistics-logo.0f37093f.png";